// extracted by mini-css-extract-plugin
export default {"textTruncate":"TextTruncate_textTruncate__2frhu"};